<template>
  <div id="main">
    <!-- <div style="display: flex; justify-content: center; padding-top: 24px; width: 100%;">
      <el-input style="width: 50%" placeholder="请输入你想搜索的商品" v-model="input" clearable>
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div> -->
    <div class="top-bar-bg">
      <div class="top-bar-inner">
        <div class="logo-block">
          <div class="logo-text">{{ COMPANY_NAME }}</div>
        </div>
        <div class="search-block">
          <span class="activity-tag bg-orange">百亿加补节</span>
          <div class="search-input-box">
            <input class="search-input" placeholder="宝贝/chic韩系穿搭" />
            <div class="top-bar-tags"> <!-- 新增热门搜索标签 -->
              <div class="hot-tags" >
                <span @click="goItem(item)" class="hot-tag" v-for="item in goodsData2.slice(8, 12)" :key="item.id">{{ item.title }}</span>
              </div>
            </div>
          </div>

          <button class="search-btn">搜索</button>
        </div>

        <div class="promo-block">
          <img src="https://ext.same-assets.com/3934484200/1100412516.gif" alt="红包活动" style="height: 42px;" />
        </div>
      </div>

    </div>
    <div style="font-size: 20px;font-weight: 600;margin-left: 30px;margin-top: 15px; color: red;"><img
        style="width: 250px;" src="@/assets/img/jrtj_02.png" alt=""></div>
    <!-- banner 样式 1 -->
    <div class="bannerAndNav-box">
      <div class="left-panel">
        <!-- 新增分类项 -->
        <div class="category-item">手机 / 笔记本 / 平板</div>
        <div class="category-item">女装 / 男装</div>
        <div class="category-item">运动鞋 / 休闲鞋 / 靴子</div>
        <div class="category-item">白酒 / 茶叶 / 咖啡</div>
        <div class="category-item">家电 / 数码 / 影音</div>
        <div class="category-item">美妆 / 个护 / 娱乐</div>
      </div>
      <div class="center-panel">
        <el-carousel trigger="click" style=" width: 50%;" height="275px">
          <el-carousel-item v-for="item in goodsData2.slice(5, 10)" :key="item.id">
            <div class="banner_box">
              <div class="banner_img">
                <img :src="item.img" style="width: 100%;" alt="">
              </div>
              <div class="banner_right">
                <h6>{{ item.title }}</h6>
                <h3 style="padding: 0 24px">{{ item.info }}</h3>
                <div class="item-price clearfix">
                  <i>¥</i><span>{{ item.price }}</span>
                </div>
                <div class="item-btns clearfix">
                  <span class="item-gray-btn">
                    <a target="_blank" @click="goItem(item)">查看详情</a>
                  </span><span class="item-blue-btn" @click="addCarPanel(item)">加入购物车
                  </span>
                </div>
              </div>
            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 这是 banner样式 2 -->
    <!-- <el-carousel :interval="4000" style="margin-top: 20px;" type="card" height="275px">
      <el-carousel-item v-for="item in goodsData2.slice(5, 10)" :key="item.id">
        <div class="banner_box">
          <div class="banner_img">
            <img :src="item.img" style="width: 100%;" alt="">
          </div>
          <div class="banner_right">
            <h6>{{ item.title }}</h6>
            <h3 style="padding: 0 24px">{{ item.info }}</h3>
            <div class="item-price clearfix">
              <i>¥</i><span>{{ item.price }}</span>
            </div>
            <div class="item-btns clearfix">
              <span class="item-gray-btn">
                <a target="_blank" @click="goItem(item)">查看详情</a>
              </span><span class="item-blue-btn" @click="addCarPanel(item)">加入购物车
              </span>
            </div>
          </div>
        </div>

      </el-carousel-item>
    </el-carousel> -->
    <!-- <div class="nav-sub">
      <div class="nav-sub-wrapper">
        <div class="container">
          <ul class="nav-list">
            <li class="active">全部</li>
            <li><a href="javascript:;">手机 / 笔记本 / 平板</a></li>
            <li><a href="javascript:;">女装 / 男装</a></li>
            <li><a href="javascript:;">运动鞋 / 休闲鞋 / 靴子</a></li>
            <li><a href="javascript:;">白酒 / 茶叶 / 咖啡</a></li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="sku-box store-content">
      <!-- <div class="sort-option">
        <ul class="line clear">
          <li><a href="javascript:;" class="active">综合排序</a></li>
          <li><a href="javascript:;" class="">销量排序</a></li>
          <li><a href="javascript:;" class="">价格低到高</a></li>
          <li><a href="javascript:;" class="">价格高到低</a></li>
        </ul>
      </div> -->
      <div class="gray-box">
        <div class="item-box">
          <shop-item v-for="(item, index) in goodsData" :key="index" v-bind:shopItem="item"></shop-item>
        </div>
        <div style="text-align: center; padding: 10px;">
          <el-button size="small" @click="onLoadMore()" :loading="loading">加载更多</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/goodsList.css";
import gD from "@/lib/newGoodsData.js";
import ShopItem from "@/components/shop-item.vue";
import goodsData from "../lib/newGoodsData";
export default {
  data() {
    return {
      goodsData: {},
      goodsData2: {},
      input: "",
      loading: false
    };
  },
  created() {
    this.postData();
  },
  methods: {
    onLoadMore() {
      //加载加载数据
      this.loading = true
      setTimeout(() => {
        this.goodsData = this.goodsData2
        this.loading = false
      }, 500);
    },
    goItem(obj) {
      // 1. 序列化对象 + URI 编码
      const encodedData = encodeURIComponent(JSON.stringify(obj));

      // 2. 构造完整 URL（注意 Hash 模式路径在 # 后）
      const url = `${window.location.origin}/#/item?itemData=${encodedData}`;

      // 3. 新窗口打开
      window.open(url, '_blank');

    },
    postData() {
      this.$axios.get(`/getGoods?page=1`).then((res) => {
        console.log(res.data);
        this.goodsData2 = res.data.data
        this.goodsData = res.data.data.slice(0, 8);//第一次只展示一小部分数据
      });
    },
    addCarPanel(data) {

      this.$store.dispatch("addCar", data);
    },
  },
  components: {
    ShopItem,
  },
};
</script>

<style>
.top-bar-bg {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px 0 #f7f7f7;
}

.top-bar-inner {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 106px;
}

.logo-block {
  display: flex;
  align-items: center;
}

.taobao-logo {
  width: 96px;
  margin-right: 12px;
}

.logo-text {
  font-size: 22px;
  color: #f42119;
  font-weight: 700;
}

.search-block {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.activity-tag.bg-orange {
  background: #f42119;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 4px 12px;
  margin-right: 10px;
}

.search-input {
  width: 360px;
  height: 38px;
  border: 1px solid #f42119;
  border-radius: 4px 0 0 4px;
  font-size: 15px;
  padding-left: 14px;
  outline: none;
}

.search-btn {
  height: 38px;
  width: 70px;
  border: none;
  border-radius: 0 4px 4px 0;
  background: #f42119;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

.promo-block {
  width: 200px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.banner_box .item-price {
  font-family: Arial;
  color: #c30a18;
  margin-top: 24px;
  text-align: center;
  opacity: 1;
}

.banner_box h3,
.banner_box h6 {
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.banner_box h3 {
  line-height: 1.2 !important;
  font-size: 12px !important;
  color: #d0d0d0;
  margin: 8px auto 14px;
}

.banner_box h6 {
  line-height: 1.2 !important;
  font-size: 16px;
  color: #424242;
  margin: 0 auto;
  padding: 0 14px;
}

.banner_box .item-price i {
  font-size: 16px;
}

.banner_box .item-price span {
  font-size: 18px;
  padding-left: 4px;
}

.banner_box .item-btns .item-blue-btn,
.banner_box .item-btns .item-disabled-btn,
.banner_box .item-btns .item-gray-btn,
.banner_box .item-btns .item-green-btn {
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
  height: 30px;
  font-size: 12px;
  line-height: 28px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 200;
  transition: all .1s ease;
}

.banner_box .item-btns .item-gray-btn {
  border: 1px solid #d5d5d5;
  color: #646464;
}

.banner_box .item-btns .item-gray-btn:hover {
  background-image: linear-gradient(#f6f6f6, #ededed);
}


.banner_box .item-btns .item-gray-btn:hover {
  background-image: linear-gradient(#f6f6f6, #ededed);
}

.banner_box .item-btns .item-blue-btn:hover {
  border: 1px solid #5374c8;
  background-color: #5074db;
  background-image: linear-gradient(#6e8ed5, #4769c2);
}

.banner_box .item-btns .item-blue-btn {
  background-color: #5c85e5;
  background-image: linear-gradient(#000000, #d65d5d);
  border: 1px solid #5c81e3;
  color: #fff;
  margin-left: 10px;
}

.banner_box {
  display: flex !important;
  height: 100%;
}

.banner_box .banner_img {
  flex: 2;
  width: 100px;
}

.banner_box .banner_right {
  display: flex;
  width: 0;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 2;
  gap: 12px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #ffffff;
}

/* 新增搜索输入框容器样式 */
.search-input-box {
  position: relative;
  /* 关键：设置相对定位 */
}

/* 调整热门标签定位样式 */
.top-bar-tags {
  position: absolute;
  /* 关键：设置绝对定位 */
  top: 100%;
  /* 相对于父容器底部对齐 */
  left: 0;
  /* 与父容器左侧对齐 */
  width: 100%;
  /* 继承父容器宽度 */
}

/* 保持原有热门标签居中样式 */
.hot-tags {
  margin-top: 8px;
  padding-left: 0;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.hot-tag {
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s;
  max-width: 5em;
  /* 限制最大宽度为5个字 */
  white-space: nowrap;
  /* 禁止换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 溢出显示省略号 */
}

.hot-tag:hover {
  color: #f42119;
  /* 与搜索按钮主色一致 */
}

/* 新增 banner 与导航分区样式 */
.bannerAndNav-box {
  display: flex; /* 启用弹性布局 */
  gap: 20px; /* 左右分区间距 */
  width: 1220px;
  margin: 20px auto 25px; /* 上下边距 + 水平居中 */
}

.left-panel {
  flex: 0 0 20%; /* 左边分类区固定占比20%（不收缩/不扩展） */
  background: #f8f8f8; /* 分类区背景色 */
  padding: 16px; /* 内边距 */
  border-radius: 4px; /* 圆角 */
}

.center-panel {
  flex: 1; /* 右边 banner 区占剩余全部空间（约80%） */
}

/* 调整 banner 轮播图宽度为100%（原样式中 width:50% 会导致显示不全） */
.center-panel .el-carousel {
  width: 100% !important;
}

/* 新增分类项样式 */
.left-panel .category-item {
  font-size: 14px;
  color: #333;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 4px; /* 分类项之间的间距 */
}

.left-panel .category-item:hover {
  background: #ffffff; /* 悬停时背景变白 */
  color: #f42119; /* 悬停时文字颜色与主题色一致 */
  transform: translateX(4px); /* 轻微右移增强交互感 */
}

</style>



// WEBPACK FOOTER //
// src/views/shop.vue